/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const aelf_chain_about = () => `aelf is primarily a multi-chain parallel computing blockchain network which was created to address several of the limitations of traditional blockchain systems, such as performance bottlenecks and data complexity. aelf's vision is to be a 'Linux Ecosystem' equivalent for a blockchain that incorporates state-of-the-art IT design principles, which in particular allows developers to customise Chains to meet their own needs.`
